import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import SrModalV2, { MODAL_THEME_FIXED_FOOTER_BUTTON } from 'client/components/SrModalV2/SrModalV2';
import { SR_BUTTON_THEME_ADOBE_GREY } from 'client/components/SrButton/SrButton';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

import './SrSupraCbsModal.less';

const SrSupraCbsModal = ({ onClose }) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  return (
    <SrModalV2
      theme={MODAL_THEME_FIXED_FOOTER_BUTTON}
      buttonTheme={SR_BUTTON_THEME_ADOBE_GREY}
      onClose={onClose}
      contentPadding="26px 20px 260px"
    >
      <SrBox styleName="SrSupraCbsModal">
        <SrBox>
          <SrText size="30" lineHeight="36px" display="block" weight="800">
            How to find the Supra Lockbox CBS Code
          </SrText>
        </SrBox>
        <SrBox marginTop="24px" overflow="hidden">
          <video width="100%" height={isSmallScreen ? '190px' : '400px'} controls>
            <source src="/videos/Supra-CBS.mp4" type="video/mp4" />
            <track src="" kind="captions" />{' '}
            {/* Autosuggest complains when we don't include the track tag */}
          </video>
        </SrBox>
        <SrBox marginTop="24px">
          <SrText size="21" weight="800">
            How to locate your CBS Code
          </SrText>
        </SrBox>
        <SrBox marginTop="6px">
          <ol>
            <li>Open your "Supra eKEY" app</li>
            <li>Tap on the "My Keyboxes" icon</li>
            <li>Select the keybox</li>
            <li>Choose "Program Keybox"</li>
            <li>The CBS code is displayed in "Keybox Settings"</li>
          </ol>
        </SrBox>
        <SrBox marginTop="24px" maxWidth="400px">
          <img width="100%" height="auto" src="/images/supra-app-preview.png" alt="supra app" />
        </SrBox>
        <SrBox marginTop="34px">
          <SrText size="30" lineHeight="36px" display="block" weight="800">
            Learn more about the Supra Lockbox
          </SrText>
        </SrBox>
        <SrBox marginTop="22px">
          <SrText size="21" weight="800">
            What is a CBS Code?
          </SrText>
        </SrBox>
        <SrBox marginTop="6px">
          <SrText opacity="0.6">
            A CBS (call before showing) code is a 7-digit code that unlocks the key pod on a Supra
            lockbox giving agents access to a property. This code allows an agent to control access
            to their listing by requiring other agents to call ahead of time to gain access to the
            Supra.
          </SrText>
        </SrBox>
      </SrBox>
    </SrModalV2>
  );
};

SrSupraCbsModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

SrSupraCbsModal.displayName = 'SrSupraCbsModal';

export default SrSupraCbsModal;
